// @ts-check
import React, { Component } from 'react';
import { reduxForm } from 'utils/reduxFormWrapper';
import { required } from 'utils/validation';
import { hideModal } from 'shared/actions/ModalActions';
import { ConditionalGroup } from 'shared/components/Providers/Ruleset/Edit/ConditionalGroup';
import { newConditionalGroup } from 'shared/components/Providers/Ruleset/Edit/utils';
import { PlainSelectField } from 'shared/containers/portal_layout/HForm';

/** @typedef {{
  updateConditionalGroup: function({ conditionalGroup:any, thenAction: "makeVisible" | "makeHidden"}): void,
  removeConditionalGroup: function() : void,
  rulableFields: Array<any>,
  handleSubmit: function(any): (any)
}} QuestionnaireItemConditionalGroupFormPropsType */

/** @augments { Component<QuestionnaireItemConditionalGroupFormPropsType, {}> } */
class QuestionnaireItemConditionalGroupForm extends Component {
  constructor() {
    super();
    this.saveConditionalGroup = this.saveConditionalGroup.bind(this);
    this.removeConditionalGroup = this.removeConditionalGroup.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
  }

  saveConditionalGroup(formValues) {
    const { conditionalGroup, thenAction } = formValues;
    this.props.updateConditionalGroup({ conditionalGroup, thenAction });
    hideModal();
  }

  removeConditionalGroup() {
    this.props.removeConditionalGroup();
    hideModal();
  }

  cancelEdit() {
    hideModal();
  }

  render() {
    return (
      <form onSubmit={this.props.handleSubmit(this.saveConditionalGroup)}>
        <div className="modal-body">
          <ConditionalGroup name="conditionalGroup" rulableFields={this.props.rulableFields} />
        </div>
        <div>
          <PlainSelectField
            name="thenAction"
            label="Then:"
            options={[
              { value: 'makeVisible', label: 'Make Visible' },
              { value: 'makeHidden', label: 'Make Hidden' },
            ]}
            validate={required}
          />
        </div>
        <div className="modal-footer">
          <button
            type="button"
            style={{ float: 'left' }}
            className="btn btn-danger left"
            onClick={this.removeConditionalGroup}
          >
            Remove Conditional
          </button>
          <button type="button" className="btn" onClick={this.cancelEdit}>
            Cancel Edit
          </button>
          <button type="submit" className="btn btn-primary">
            Save
          </button>
        </div>
      </form>
    );
  }
}

const FormifiedQuestionnaireItemConditionalGroupForm = reduxForm({
  form: 'questionnaireItemConditionalGroup',
})(QuestionnaireItemConditionalGroupForm);

const QuestionnaireItemConditionalGroupModal = ({
  rulableFields,
  updateConditionalGroup,
  conditionalGroup,
  thenAction,
  removeConditionalGroup,
}) => (
  <div>
    <div className="modal-header">
      <h3>Questionnaire Item Conditional Group</h3>
    </div>
    <FormifiedQuestionnaireItemConditionalGroupForm
      initialValues={{
        conditionalGroup: conditionalGroup || newConditionalGroup(),
        thenAction,
      }}
      rulableFields={rulableFields}
      updateConditionalGroup={updateConditionalGroup}
      removeConditionalGroup={removeConditionalGroup}
    />
  </div>
);

export default QuestionnaireItemConditionalGroupModal;
